import Locale from 'src/i18n';
import { formatMessage } from 'src/i18n/intl';
import { isImmutable } from 'immutable';
import { VALIDATION_REGEXP } from 'src/features/users-v2/constants';
import { checkIfUserHaveGivenPermissions } from 'src/util/Util';
import { PERMISSIONS } from 'src/constants';
import { EDIT_EXTERNAL_IDP } from 'src/features/authentication-v2/constants';

const calculateStatus = status => {
    let statusValue;
    let statusColor;

    if (status === 'disabled') {
        statusValue = formatMessage(Locale.disabled);
        statusColor = 'grey';
    } else if (status === 'active') {
        statusValue = formatMessage(Locale.userStatusActive);
        statusColor = 'green';
    } else if (status === 'pending') {
        statusValue = formatMessage(Locale.userStatusPending);
        statusColor = 'tangerine';
    } else if (status === 'expired') {
        statusValue = formatMessage(Locale.expired);
        statusColor = 'salmon';
    }
    return [statusValue, statusColor];
};

export const getLoginSchemeName = loginSchemeState => {
    if (loginSchemeState && loginSchemeState.label) {
        return loginSchemeState.label;
    }

    const loginScheme = loginSchemeState && isImmutable(loginSchemeState) ? loginSchemeState.toJS() : false;
    if (loginScheme) {
        return loginScheme.label;
    }

    return loginSchemeState;
};

export const isValidFieldValue = (field, value = '') => {
    const regex = VALIDATION_REGEXP[field];
    if (regex) {
        return !!value.match(regex);
    }

    return true;
};

export const shouldDisableUserDetails = screenKey => {
    if (screenKey === EDIT_EXTERNAL_IDP) {
        const isViewUserAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_VIEW]);
        const isViewAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_VIEW]);
        const isUpdateAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_UPDATE]);
        if (isUpdateAvailiable && isViewUserAvailiable) {
            return false;
        }
        if (isViewAvailiable && isViewUserAvailiable) {
            return true;
        }
        return false;
    }

    const isViewAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_VIEW]);
    const isUpdateAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_UPDATE]);

    if (isUpdateAvailiable) {
        return false;
    }
    if (isViewAvailiable) {
        return true;
    }
    return false;
};

export const handleNoUserPermissionsPresent = screenKey => {
    const isViewAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_VIEW]);
    const isUpdateAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_UPDATE]);
    const isNeitherUsersAvailiable = !(isViewAvailiable || isUpdateAvailiable);
    if (isNeitherUsersAvailiable) {
        return true;
    }
    if (screenKey === EDIT_EXTERNAL_IDP) {
        const isViewAuthAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_VIEW]);
        if (!isViewAuthAvailiable) {
            return true;
        }
        return false;
    }
    return false;
};

export default calculateStatus;
